import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemCourgetteSeeds extends Item {
    constructor() {
        super(definitions.ITEM_ID.COURGETTE_SEEDS, texture("prop_courgette_seeds_00"));
    }

    init() {    
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.6, new PIXI.Point(3, 0));
    }
}